export const MUVATTUPUZHA_BRANCH_ID = "641013cb4dc110721d67a442";
